import { lazy } from 'react';
import { MultiApp } from '@/config/context';
import { IRouteConfig } from '../types';

export const trialRoutes = (): IRouteConfig[] => [
  {
    path: '/trial-apply',
    exact: true,
    name: '',
    component: lazy(() => import('@/presentation/pages/trial/apply')),
    hideInMenu: true,
    versions: [MultiApp.Pro, MultiApp.Sgp],

  },
  {
    path: '/trial-approval',
    exact: true,
    name: '运营活动审批',
    component: lazy(() => import('@/presentation/pages/trial/approval')),
    hideInMenu: true,
    versions: [MultiApp.Pro, MultiApp.Sgp],
  },
];

export default trialRoutes;
